import {PAEnvironment} from '../PA.Core/PAEnvironment';

export class ApplicationManagerRegistry  {

    public static AppType_About: string = "About";
    public static AppType_UserDashboard: string = "UserDashboard";
    public static AppType_Set: string = "Set"
    public static AppType_Approval: string = "Approval";
    public static AppType_Source: string = "Source"
    public static AppType_Customer: string = "Customer";
    public static AppType_CustomerHierarchy: string = "CustomerHierarchy"
    public static AppType_CustomerType: string = "CustomerType"
    public static AppType_Product: string = "Product"
    public static AppType_ConsumerProduct: string = "ConsumerProduct"
    public static AppType_ProductGroup: string = "ProductGroup"
    public static AppType_ProductHierarchy: string = "ProductHierarchy"
    public static AppType_ProductType: string = "ProductType"
    public static AppType_Period: string = "Period"
    public static AppType_Setting: string = "String"
    public static AppType_SettingType: string = "SettingType"
    public static AppType_Note: string = "Note"
    public static AppType_Domain: string = "Domain"
    public static AppType_DomainItem: string = "DomainItem"
    public static AppType_User: string = "User"
    public static AppType_AuthProvider: string = "AuthProvider"
    public static AppType_PlanSearch: string = "PlanSearch"
    public static AppType_PlanGroup: string = "PlanGroup"
    public static AppType_Plan: string = "Plan"
    public static AppType_Event: string = "Event"
    public static AppType_TPMPlan: string = "TPMPlan"
    public static AppType_TPMEvent: string = "TPMEvent"
    public static AppType_SpendType: string = "SpendType"
    public static AppType_Tag: string = "Tag"
    public static AppType_TagSource: string = "TagSource"
    public static AppType_Tag_Function: string = "TagFunction"
    public static AppType_TagRule: string = "TagRule"
    public static AppType_Meta: string = "Meta"
    public static AppType_ProductCondition: string = "ProductCondition"
    public static AppType_ConditionType: string = "ConditionType"
    public static AppType_View: string = "View"
    public static AppType_PlanAnalyzer: string = "Plan Analyzer"
    public static AppType_PricingCalc: string = "PricingCalc"
    public static AppType_PricingEngine: string = "PricingEngine"
    public static AppType_Job: string = "Job"
    public static AppType_JobProcessor: string = "JobProcessor"
    public static AppType_ReportingWorkspace: string = "ReportingWorkspace"
    public static AppType_ReportTile: string = "ReportTile"
    public static AppType_Connection: string = "Connection"
    public static AppType_Dimension: string = "Dimension"
    public static AppType_EDLPAnalysis: string = "EDLPAnalysis"
    public static AppType_Snapshot: string = "Snapshot"
    public static AppType_ModelFormMgt: string = "Model Form Mgt"
    public static AppType_Mappings: string = "Mappings"
    public static AppType_Scaling: string = "Scaling"
    public static AppType_Calendar: string = "Calendar"
    public static AppType_CannibalizationSet: string = "CannibalizationSet"
    public static AppType_ROIDefaults: string = "ROIDefaults"
    public static AppType_SoldToHierarchy: string = 'SoldToHierarchy'
    public static AppType_AutoAnchoring: string = 'AutoAnchoring'
    public static AppType_HierarchyMgt: string = 'HierarchyMgt'
    public static AppType_GeneralLedger: string = 'GeneralLedger'
    public static AppType_GeneralLedgerPolicy: string = 'GeneralLedgerPolicy'
    public static AppType_FundType: string = 'FundType'
    public static AppType_Transaction: string = 'Transaction'
    public static AppType_TransactionType: string = 'TransactionType'
    public static AppType_Workflow: string = 'Workflow'
    public static AppType_Baseline: string = 'Baseline'
    public static AppType_PlanManagement: string = 'PlanManagement'
    public static AppType_EventType: string = "EventType"
    public static AppType_EventSpendType: string = "EventSpendType"
    public static AppType_PlanType: string = 'PlanType'
    public static AppType_PaymentType: string = 'PaymentType'
    public static AppType_Payment: string = 'Payment'
    public static AppType_UserGroup: string = "UserGroup"
    public static AppType_MetricView: string = "MetricView"
    public static AppType_MetricDefinition: string = "MetricDefinition"
    public static AppType_SnapshotType: string = "SnapshotType"
    public static AppType_JobScheduler: string = "JobScheduler"
    public static AppType_BusinessUnit: string = "BusinessUnit"
    public static AppType_SubjectArea: string = "SubjectArea"
    public static AppType_Loader: string = "Loader"
    public static AppType_LoaderOperation: string = "LoaderOperation"
    public static AppType_LoaderSource: string = "LoaderSource"
    public static AppType_Report: string = "Report"
    public static AppType_ProductAttributeGroup: string = "ProductAttributeGroup"
    public static AppType_ProductAttributeMap: string = "ProductAttributeMap"
    public static AppType_PeriodHierarchy: string = "PeriodHierarchy"
    public static AppType_ModelPredictor: string = "ModelPredictor";
    public static AppType_ModelCannibalizationType: string = "ModelCannibalizationType";
    public static AppType_ModelFunction: string = "ModelFunction";
    public static AppType_ModelingSession: string = "ModelingSession";
    public static AppType_Model : string = "Model";
    public static AppType_ModelTerm: string = "ModelTerm";
    public static AppType_CustomColumn : string = "CustomColumn";
    public static AppType_ModelVolumeComponent: string = "ModelVolumeComponent";
    public static AppType_ScenarioSpendMethod: string = "ScenarioSpendMethod";
    public static AppType_ModelCoefficient: string = "ModelCoefficient";
    public static AppType_DataSetTagRule: string = "DataSetTagRule";
    public static AppType_ModelDataSet: string = "ModelDataSet";
    public static AppType_ModelEngine: string = "ModelEngine";
    public static AppType_ModelCoefficientSet: string = "ModelCoefficientSet";
    public static AppType_ModelInput: string = "ModelInput";
    public static AppType_ReportingWorkspaceContext: string = "ReportingWorkspaceContext";
    public static AppType_TPMBulkApproval: string = "TPMBulkApproval";
    public static AppType_PublishedModel: string = "PublishedModel";
    public static AppType_M360: string = "Marketing360";
    public static AppType_SimulationType: string = "SimulationType";
    public static AppType_SimulationInput: string = "SimulationInput";
    public static AppType_UIProfile: string = "UIProfile";
    public static AppType_AppSuiteType: string = "AppSuiteType";
    public static AppType_AppSuite: string = "AppSuite";
    public static AppType_AppExec: string = "AppExec";
    public static AppType_AppModule: string = "AppModule";
    public static AppType_Application: string = "Application";
    public static AppType_Launchpad: string = "Launchpad";
    public static AppType_License: string = "License";
    public static AppType_Partition: string = "Partition";
    public static AppType_Simulation: string = "Simulation";
    public static AppType_CBO: string = "CBO";
    public static AppType_Benchmark: string = "Benchmark";
    public static AppType_ModelDataSource: string = "ModelDataSource";
    public static AppType_SpendFunction: string = "SpendFunction";
    public static AppType_ModelPowerMetric: string = "ModelPowerMetric";

    constructor(){
        //
    }


    static register(){
        PAEnvironment.setValue(PAEnvironment.UIAppManagerRegistry , new ApplicationManagerRegistry());
    }

}
